import React from 'react'
import { useTranslation } from 'react-i18next'
import DatePicker from 'components/DatePicker'

function DateFilters({ renderIf }) {
  const { t } = useTranslation()
  return Boolean(renderIf) && (
    <div className='columns shrink u-mt-150 u-mt-200-large-up'>
      <div className='label u-text-uppercase u-mb-50' id='filter-date-from'>{t('Timeframe')}</div>
      <div className='u-flex u-align-center'>
        <div className='u-flex u-align-center u-pr-50'>
          <div className='form-item u-flex u-align-center'>
            <label htmlFor='date_from' className='label u-inline-block u-mr-50'>{t('From')}</label>
            <DatePicker placeholder={t('From')} id='date_from' param="date_from"/>
          </div>
        </div>
        <div className='u-flex u-align-center u-pl-50'>
          <div className='form-item u-flex u-align-center'>
            <label htmlFor='date_to' className='label u-inline-block u-mr-50'>{t('To')}</label>
            <DatePicker placeholder={t('To')} id='date_to' param="date_to"/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DateFilters
